import {
  RichCardInterface,
  RichCardActionInterface
} from '@/models/templates/RichCard.interface'

// The API returns richCards but accepts richCardsAttributes.
const rcsActionAttributes = ({
  action,
  position
}: {
  action: RichCardActionInterface
  position: number
}) => ({
  text: action.text,
  actionType: action.actionType,
  url: action.url,
  phoneNumber: action.phoneNumber,
  position
})

const richCardAttributes = ({
  card,
  position
}: {
  card: RichCardInterface
  position: number
}) => ({
  imageId: card.imageId ?? null,
  title: card.title ?? null,
  position,
  buttonsAttributes: (card.buttons ?? []).map((action, index) =>
    rcsActionAttributes({ action, position: index })
  )
})

export { rcsActionAttributes, richCardAttributes }
